export default "__VITE_ASSET__aqXy5iQC__"